<template>
  <create-dialog
    width="80%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-2">
          <fg-input
            type="number"
            :label="`${$t('common_words.order_request')}: *`"
            v-model="model.order"
            v-validate="modelValidations.order"
            name="common_words.order_request"
            :error="getError('common_words.order_request', true)"
          >
          </fg-input>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-6`">
          <fg-input
            :label="`${$t('common_words.name')}: *`"
            ref="name"
            type="text"
            v-model="model.name"
            v-validate="modelValidations.name"
            name="calibration.calibrationtypes"
            :error="getError('calibration.calibration', true)"
            :placeholder="`${$t('calibration.calibration')}`"
          >
          </fg-input>
        </div>
        <div :class="`col-12`">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-calibration-type',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) {
        this.openModal('create', newValue.disabledField);
        this.setOrder();
      } else {
        this.closeModal('create', newValue.disabledField);
      }
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinPermissions,
    MixinLoading,
    MixinValidations,
  ],
  data() {
    return {
      disabledField: false,
      businessesInitial: [],
      model: {
        name: null,
        order: null,
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        name: { required: true },
        order: { required: true, min_value: 1 },
      },
    };
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
    setOrder() {
      const tableData = JSON.parse(sessionStorage.getItem('tableCode')) || [];
      const orders = tableData
        .map((data) => Number(data.order))
        .filter((order) => !isNaN(order));
      const maxOrder = orders.length ? Math.max(...orders) : 0;
      this.model.order = maxOrder + 1;
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, name, order } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = {
        ...this.model,
        id,
        name,
        order,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
